import React from 'react';
import classNames from 'classnames';
import annotationIcon from '../../icons/non-prefilled/16x16/annotation.svg';
import SVGIcon from '../../components/SVGIcon';
import styles from './AnnotationIcon.module.scss';

interface AnnotationIconProps extends React.ComponentProps<typeof SVGIcon> {
  hasContainer?: boolean;
}

const AnnotationIcon = ({ hasContainer, ...props }: AnnotationIconProps) =>
  hasContainer ? (
    <div className={styles.container}>
      <SVGIcon {...props}>{annotationIcon}</SVGIcon>
    </div>
  ) : (
    <SVGIcon {...props} className={classNames(styles.icon, props.className)}>
      {annotationIcon}
    </SVGIcon>
  );

export default AnnotationIcon;
